'use client';

import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useMemo } from 'react';
import { createDynamicTheme } from '../lib/theme';
import { useColors } from '../contexts/ColorContext';

interface ThemeProviderProps {
  children: React.ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
    const { colors } = useColors();

    // Create theme based on dynamic colors
    const theme = useMemo(() => createDynamicTheme(colors), [colors]);
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
} 